import { createContext, useContext, useState } from 'react';

const ModalContext = createContext({
  component: null,
  props: {},
  showModal: () => {},
  hideModal: () => {},
});

const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    component: null,
    props: {},
  });

  const showModal = (component, props = {}) => {
    setModal({ component, props });
  };

  const hideModal = () => {
    setModal({ component: null, props: {} });
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal, ...modal }}>
      {children}
    </ModalContext.Provider>
  );
};

const ModalConsumer = ModalContext.Consumer;
const useModal = () => useContext(ModalContext);

export { ModalConsumer, useModal };

export default ModalProvider;
